export const LOAD_OVERALLALERTS_SUCCESS = 'LOAD_OVERALLALERTS_SUCCESS';
export const UPDATE_ALERT_ROWS = 'UPDATE_ALERT_ROWS';
export const POST_ALERT_NEW_STATUS_SUCCESS = 'POST_ALERT_NEW_STATUS_SUCCESS';
export const POST_ALERT_REMOVE_NEW_STATUS_SUCCESS = 'POST_ALERT_REMOVE_NEW_STATUS_SUCCESS';
export const GET_ALERTS_COUNT_BY_ENTITY = 'GET_ALERTS_COUNT_BY_ENTITY';
export const GET_ALERTS_COUNT_BY_DATE = 'GET_ALERTS_COUNT_BY_DATE';
export const POST_SEARCH_ALERTS_SUCCESS = 'POST_SEARCH_ALERTS_SUCCESS'; //
export const POST_SEARCH_NEW_ALERTS_SUCCESS = 'POST_SEARCH_NEW_ALERTS_SUCCESS';
export const GET_COMMENTS_SUCCESS = 'GET_COMMENTS_SUCCESS';
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS';
export const ADD_COMMENTS_SUCCESS = 'ADD_COMMENTS_SUCCESS';
export const GET_USER_NAME_SUCCESS = 'GET_USER_NAME_SUCCESS';
export const GET_ALERT_BY_ID_SUCCESS = 'GET_ALERT_BY_ID_SUCCESS';
export const UPDATE_SELECTED_ALERT_ROWS = 'UPDATE_SELECTED_ALERT_ROWS';

export const SET_SEVERITY = 'SET_SEVERITY';
export const SET_SEVERITY_ALL = 'SET_SEVERITY_ALL';
export const SET_SEVERITY_HIGH_CRITICAL = 'SET_SEVERITY_HIGH_CRITICAL';

export const GET_ALERT_PROCESS_TREE_REQUEST = 'GET_ALERT_PROCESS_TREE_REQUEST';
export const GET_ALERT_PROCESS_TREE_SUCCESS = 'GET_ALERT_PROCESS_TREE_SUCCESS';
export const GET_ALERT_PROCESS_TREE_FAILURE = 'GET_ALERT_PROCESS_TREE_FAILURE';
export const SET_SITES_PER_USER = 'SET_SITES_PER_USER';
